// contexts/ToastContext.js - NEW FILE
import React, { createContext, useContext } from 'react';
import useToast from './useToast';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toastMethods = useToast();
  
  return (
    <ToastContext.Provider value={toastMethods}>
      {children}
    </ToastContext.Provider>
  );
};

export const useGlobalToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useGlobalToast must be used within ToastProvider');
  }
  return context;
};
